import { makeBEM } from "@aeo/core/utils";
import { Button } from "ebs-design";

type HTMLAnchorAttributes = JSX.IntrinsicElements["a"];
interface Props extends HTMLAnchorAttributes {}

const bem = makeBEM("login-with-mpass-link-button");

const loginPageURL = process.env.REACT_APP_MPASS_LOGIN_URL;
const mPassBaseURL = process.env.REACT_APP_MPASS_BASE_URL;

export const ConfirmWithMPassLinkButton = ({ className, ...props }: Props) => {
  if (!loginPageURL || !mPassBaseURL) return null;

  const logoURL = new URL(
    "/images/logos/mpass-logo.png",
    mPassBaseURL,
  ).toString();

  return (
    <a href={loginPageURL} {...props}>
      <Button>
        <span>Confirmă prin </span>
        <img className={bem("logo")} src={logoURL} alt="MPass" />
      </Button>
    </a>
  );
};
